import { CompanyFragment } from '@willow/graphql-iso/src/portal';

import { PaymentsPaused } from '../payments-paused/PaymentsPaused';

interface Props {
  company: CompanyFragment;
}

// Future enhancement: rename component
export const LoanPaymentsPaused = ({ company }: Props) => {
  return <PaymentsPaused company={company} title="Payments temporarily paused" subtitle={undefined} />;
};
